import React, { useState } from 'react';
import { Button } from "@curves/ui-base";
import { BlankFormMenu } from '@icoach/documents/components/index';

const BlankFormBox = (props) => {
    const { sourceData } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpenMenu = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    return (
        <div className={'btn-group'}>
            <Button variant="outlined" color="secondary" onClick={handleOpenMenu}>
                列印空白表單
            </Button>
            <BlankFormMenu anchorEl={anchorEl} sourceData={sourceData} open={open} handleClose={handleCloseMenu} />
        </div>
    );
};

export default BlankFormBox;
